import React from "react";
import { Tab, withStyles } from "@material-ui/core";

export const StyledTab = withStyles((theme) => ({
    root: {
        height: 50,
        // minHeight: "auto",
        // minWidth: "50%",
        textTransform: 'none',
        fontSize: 20,
        // fontWeight: 600,
        borderBottom: '3px solid #999999',
        [theme.breakpoints.down('lg')]: {
            fontSize: 16,
            minWidth: "130px",
            width: "130px",
            height: 40,
            minHeight: 40,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: 12,
            minWidth: "110px",
            width: "110px",
            height: 30,
            minHeight: 30,
        },
        [theme.breakpoints.down('sm')]: {
            minWidth: "50%",
            height: 40,
            minHeight: 40,
            fontSize: 16,
        },
         [theme.breakpoints.down('xs')]: {
            fontSize: 12,
            minWidth: "110px",
            width: "110px",
            height: 30,
            minHeight: 30,
        },
    },
    selected: {
        color: '#006276',
        // backgroundColor: '#F0F3F4',
        borderBottom: '3px solid #006276',
        [theme.breakpoints.down('lg')]: {
            fontSize: 16,
            minWidth: "130px",
            width: "130px",
            height: 40,
            minHeight: 40,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: 12,
            minWidth: "110px",
            width: "110px",
            height: 30,
            minHeight: 30,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
            minWidth: "130px",
            width: "130px",
            height: 40,
            minHeight: 40,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: 12,
            minWidth: "110px",
            width: "110px",
            height: 30,
            minHeight: 30,
        },
    },
}))(Tab);
